
import axios from '../axios'
import Vue from 'vue'
// 获取子管理员列表
export const getSubAdminList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/subadmin',
    method: 'get',
    params: data
  })
}
// 添加子管理员
export const addSubAdmin = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/subadmin',
    method: 'post',
    data
  })
}

// 修改子管理员
export const modifySubAdmin = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/subadmin',
    method: 'patch',
    data
  })
}

// 删除子管理员
export const delSubAdmin = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/subadmin',
    method: 'delete',
    data
  })
}

// 获取老师列表
export const getTeacherList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/teacher',
    method: 'get',
    params: data
  })
}

// 搜索老师列表
export const searchTeacher = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/teachersearch',
    method: 'get',
    params: data
  })
}
// 添加老师
export const addTeacher = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/teacher',
    method: 'post',
    data
  })
}

// 修改老师
export const modifyTeacher = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/teacher',
    method: 'patch',
    data
  })
}

// 删除老师
export const delTeacher = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/teacher',
    method: 'delete',
    data
  })
}

// 获取学生列表
export const getStudentList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/student',
    method: 'get',
    params: data
  })
}

// 搜索学生列表
export const searchStudent = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentsearch',
    method: 'get',
    params: data
  })
}
// 添加学生
export const addStudent = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/student',
    method: 'post',
    data
  })
}

// 修改学生
export const modifyStudent = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/student',
    method: 'patch',
    data
  })
}

// 删除学生
export const delStudent = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/student',
    method: 'delete',
    data
  })
}

// 获取老师列表
export const getAssistantList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/assistant',
    method: 'get',
    params: data
  })
}
// 添加老师
export const addAssistant = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/assistant',
    method: 'post',
    data
  })
}

// 修改老师
export const modifyAssistant = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/assistant',
    method: 'patch',
    data
  })
}

// 删除老师
export const delAssistant = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/assistant',
    method: 'delete',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/userManager.js